import type { AppPage } from './appRoutes';

export interface PageMetadata {
  path: string;
  title: string;
  description: string;
}

/** Indexable static routes. Each needs its own title and description. */
export const STATIC_PAGE_METADATA: Partial<Record<AppPage, PageMetadata>> = {
  home: {
    path: '/',
    title: 'Produse locale direct de la producători | roade.ro',
    description: 'roade.ro - Platformă de anunțuri pentru produse agricole și piața locală. Cumpără și vinde produse agricole proaspete direct de la producători.',
  },
  about: {
    path: '/about',
    title: 'Despre roade.ro – piața producătorilor locali',
    description: 'Află ce este roade.ro, cum publici un anunț de vânzare sau o cerere de cumpărare și cine operează platforma.',
  },
  contact: {
    path: '/contact',
    title: 'Contact | roade.ro',
    description: 'Scrie echipei roade.ro prin formularul de contact sau la contact@roade.ro pentru întrebări, sugestii și sesizări.',
  },
  terms: {
    path: '/terms',
    title: 'Termeni și condiții | roade.ro',
    description: 'Termenii și condițiile de utilizare a platformei roade.ro: conturi, anunțuri și obligațiile vânzătorilor și ale cumpărătorilor.',
  },
  privacy: {
    path: '/privacy',
    title: 'Politica de confidențialitate | roade.ro',
    description: 'Ce date personale prelucrează roade.ro, în ce scopuri și ce drepturi ai în legătură cu ele.',
  },
  cookies: {
    path: '/cookies',
    title: 'Politica de cookie-uri | roade.ro',
    description: 'Ce cookie-uri și tehnologii similare folosește roade.ro și cum îți poți schimba preferințele.',
  },
  searchRankingHelp: {
    path: '/help/search-ranking',
    title: 'Cum sunt ordonate rezultatele? | roade.ro',
    description: 'Află cum selectează și ordonează roade.ro anunțurile după filtre, data publicării și preț.',
  },
};

const setMeta = (attribute: 'name' | 'property', key: string, content: string) => {
  let meta = document.querySelector(`meta[${attribute}="${key}"]`) as HTMLMetaElement | null;
  if (!meta) {
    meta = document.createElement('meta');
    meta.setAttribute(attribute, key);
    document.head.appendChild(meta);
  }
  meta.content = content;
};

export const applyPageMetadata = ({ path, title, description }: PageMetadata) => {
  document.title = title;
  setMeta('name', 'description', description);
  setMeta('property', 'og:title', title);
  setMeta('property', 'og:description', description);
  setMeta('property', 'og:url', `${window.location.origin}${path}`);
  setMeta('name', 'twitter:title', title);
  setMeta('name', 'twitter:description', description);
};
